export const productsName = {
    Own: 'Propia',
    Provider: 'Proveedor',
    Finket: 'Cuenta Propia',
    Goal: 'Cuenta Meta',
    External: 'Externa',
    MyCommerce: 'Cuenta Comercio',
    Tax: 'Impuesto',

    // 1001: 'Claro',
    // 1002: 'Movistar',
    // 1003: 'Personal',
    // 1004: 'Nextel',
    // 1005: 'Gran DT',
    // 1006: 'Goleadores',
    // 1007: 'DirectTv',
    // 1008: 'Tuenti',
    // 1009: 'SUBE',
    // 1010: 'Antina Prepago',
    // 1011: 'Tarjeta SUBE',
    // 2001: 'Colon Seguros - celulares',
    // 2002: 'Cuotitas',
};
